import React, { Component, useState } from 'react';
import CustomImage from '../../components/custom-image';

const EnvironmentalPractices = () => {
  return (
    <div className="awards-content buttom-section">
      <div className="one-col">
        <h4>Environmental Practices</h4>
        <div className="table-wrapper">
          <div className="desktop-img">
            <CustomImage
              className="icon-arrow-up"
              imageName="environmental-practices.png"
              alt="Environmental Practices"
              maxWidth="895"
            />
          </div>
          <div className="mobile-img">
            <div className="table-img">
              <CustomImage
                className="icon-arrow-up"
                imageName="environmental-practices-mobile.png"
                alt="Environmental Practices"
                maxWidth="895"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnvironmentalPractices;
